import { useEffect, Suspense, lazy } from 'react'; // 1. Lisa Suspense ja lazy
import { BrowserRouter, Routes, Route, Navigate, useParams, Outlet } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

// --- STAATILISED IMPORDID (Need laetakse kohe) ---
// Header, Footer ja ScrollToTop peavad olema kohe olemas, et leht ei "hüppaks"
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

// --- DÜNAAMILISED IMPORDID (Code Splitting) ---
// Need laetakse alles siis, kui kasutaja vastavale lehele läheb
const Home = lazy(() => import('./pages/Home'));
const Contact = lazy(() => import('./pages/Contact'));
const Services = lazy(() => import('./pages/Services'));
const About = lazy(() => import('./pages/About'));
const BlogIndex = lazy(() => import('./pages/BlogIndex'));
const BlogPost = lazy(() => import('./pages/BlogPost'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Portfolio = lazy(() => import('./pages/Portfolio'));
const CaseStudy = lazy(() => import('./pages/CaseStudy'));
const NotFound = lazy(() => import('./pages/NotFound'));
const WebsiteForBusiness = lazy(() => import('./pages/WebsiteForBusiness'));
const KodulehePage = lazy(() => import('./pages/KodulehePage'));
const EpoodPage = lazy(() => import('./pages/EpoodPage'));
const ErpPage = lazy(() => import('./pages/ErpPage'));

// Abikomponent keele haldamiseks
const LanguageWrapper = () => {
  const { lang } = useParams();
  const { i18n } = useTranslation();

  useEffect(() => {
    const supportedLanguages = ['et', 'en'];
    if (lang && supportedLanguages.includes(lang)) {
      if (i18n.language !== lang) i18n.changeLanguage(lang);
      document.documentElement.lang = lang;
    }
  }, [lang, i18n]);

  if (lang && !['et', 'en'].includes(lang)) {
    return <Navigate to="/et" replace />;
  }

  return <Outlet />;
};

function App() {
  const { t } = useTranslation();

  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-6 focus:py-3 focus:bg-blue-600 focus:text-white focus:rounded-lg focus:font-bold focus:shadow-lg"
        >
          {t('skip_nav')}
        </a>
        <div className="flex flex-col min-h-screen">

          <Header />

          <main id="main-content" className="flex-grow">
            {/* Suspense tegeleb "loading" olekuga, kuni lazy komponent laeb.
                fallback={<...>} on see, mida näidatakse laadimise ajal.
                Siin on lihtne tume taust, et vältida valget välgatust.
            */}
            <Suspense fallback={<div className="min-h-screen bg-[#0f172a]"></div>}>
              <Routes>
                {/* --- SUUNAMISED --- */}
                <Route path="/" element={<Navigate to="/et" replace />} />
                <Route path="/blog" element={<Navigate to="/en/blog" replace />} />

                {/* --- KEELEPÕHISED RUUDUD --- */}
                <Route path="/:lang" element={<LanguageWrapper />}>
                  <Route index element={<Home />} />
                  <Route path="services" element={<Services />} />
                  <Route path="about" element={<About />} />
                  <Route path="contact" element={<Contact />} />
                  <Route path="privacy" element={<Privacy />} />
                  
                  <Route path="case-studies" element={<Portfolio />} />
                  <Route path="case-studies/:id" element={<CaseStudy />} />

                  <Route path="blog" element={<BlogIndex />} />
                  <Route path="blog/:slug" element={<BlogPost />} />

                  <Route path="veebileht-ettevotele" element={<WebsiteForBusiness />} />
                  <Route path="kodulehe-tegemine" element={<KodulehePage />} />
                  <Route path="e-poe-tegemine" element={<EpoodPage />} />
                  <Route path="erp-integratsioon" element={<ErpPage />} />

                  <Route path="*" element={<NotFound />} />
                </Route>
              </Routes>
            </Suspense>
          </main>
          
          <CookieConsent />
          <Footer />
          
        </div>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
